import styled from 'styled-components';
import endPoints from '../../config/endPoints';
import theme from '../../theme';

const ZaggleCard = styled.div`
  .card{
    background :url(${endPoints.ZAGGLECARD.URL}) no-repeat;
    background-size:cover;
    height: 280px;
    position: relative;
    h1{
      padding: 0px;
      margin: 0px;
      font-size: 28px;
      color: ${(props) => props.theme.whiteColor};
    }
    h2{
      padding: 0px;
      margin: 0px;
      font-size: 18px;
      color: ${(props) => props.theme.whiteColor};
    }
    .footer{
      position: absolute;
      width: 92%;
      bottom: 10%;
      color: ${(props) => props.theme.whiteColor};
      button{
        background: ${(props) => props.theme.whiteColor};
        color: ${(props) => props.theme.secondaryColor};
      }
    }
  }
  .card-details{
    b{
      color: ${(props) => props.theme.primaryColor};
      font-size:22px;
    }
    p{
      color: ${(props) => props.theme.grayColor};
    }
    img{
      width:15px;
    }
  }
  button{
    a{
      color: rgba(0,0,0,.6);
    }
  }
  /* need to be removed */
  .walletTable{
    .rt-thead{
      background: ${(props) => props.theme.lightWhite};
      border: none;
      .rt-th{
        border:none;
        text-align:left;
      }
    }
  }
`;

const FlipCards = styled.div`
  cursor: pointer;
  height: 250px;
  perspective: 600;
  position: relative;
  width: 100%;
  input[type='checkbox'] {
  display: none;
}
  input[type='checkbox']:checked + .card-containert .card-flip {
  transform: rotateY(180deg);
}
  .card-flip {
    height: 100%;
    position: absolute;
    transform-style: preserve-3d;
    transition: all 1s ease-in-out;
    width: 400px;
    cursor: pointer;
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
      width:100%;
    };
    &.default{
      transform-style: none;
      transition: none;
      &:hover{
        transform: none;
      }
      .default-user{
        background :url(${endPoints.ZAGGLECARD.URL}) no-repeat;
        padding: 30px 0px 0px 35px;
        background-size: cover;
      }
    }
  }
  .card-flip .side {
    backface-visibility: hidden;
    border-radius: 6px;
    height: 100%;
    position: absolute;
    overflow: hidden;
    width: 100%;
    background :url(${endPoints.ZAGGLE_CARD_FRONT.URL}) no-repeat;
    background-size:cover;
    padding: 60px 0px 0px 35px;
    &.default-user{
      background :url(${endPoints.ZAGGLECARD.URL}) no-repeat !important;
    }
    h1{
      padding: 0px;
      margin: 0px;
      font-size: 28px;
      color: ${(props) => props.theme.whiteColor};
    }
    h2{
      padding: 0px;
      margin: 0px;
      font-size: 18px;
      color: ${(props) => props.theme.whiteColor};
    }
    .footer{
      margin-top: 12%;
      color: ${(props) => props.theme.whiteColor};
      button{
        background: ${(props) => props.theme.whiteColor};
        color: ${(props) => props.theme.secondaryColor};
      }
    }
    img{
      width:100%;
    }
  }
  .card-flip .back {
    background: #eaeaed;
    color: #0087cc;
    line-height: 150px;
    text-align: center;
    transform: rotateY(180deg);
    background :url(${endPoints.ZAGGLE_CARD_BACK.URL}) no-repeat;
    background-size:cover;
    padding-top: 35px;
    h3{
      color: ${(props) => props.theme.blackColor};
      font-weight: 900;
      text-align: center;
      padding-left: 24%;
    }
    .footer{
      display:none;
    }
  }
`;

const NsdlFlipCards = styled.div`
  cursor: pointer;
  height: 250px;
  perspective: 600;
  position: relative;
  width: 100%;
  input[type='checkbox'] {
  display: none;
}
  input[type='checkbox']:checked + .card-containert .card-flip {
  transform: rotateY(180deg);
}
  .card-flip {
    height: 100%;
    position: absolute;
    transform-style: preserve-3d;
    transition: all 1s ease-in-out;
    width: 400px;
    cursor: pointer;
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
      width:100%;
    };
    &.default{
      transform-style: none;
      transition: none;
      &:hover{
        transform: none;
      }
      .default-user{
        background :url(${endPoints.ZAGGLECARD.URL}) no-repeat;
        padding: 30px 0px 0px 35px;
        background-size: cover;
      }
    }
  }
  .card-flip .side {
    backface-visibility: hidden;
    border-radius: 6px;
    height: 100%;
    position: absolute;
    overflow: hidden;
    width: 100%;
    background :url(${endPoints.ZAGGLE_CARD_FRONT_NSDL.URL}) no-repeat;
    background-size:cover;
    padding: 60px 0px 0px 35px;
    &.default-user{
      background :url(${endPoints.ZAGGLECARD.URL}) no-repeat !important;
    }
    h1{
      padding: 0px;
      margin: 0px;
      font-size: 28px;
      color: ${(props) => props.theme.whiteColor};
    }
    h2{
      padding: 0px;
      margin: 0px;
      font-size: 18px;
      color: ${(props) => props.theme.whiteColor};
    }
    .footer{
      margin-top: 15%;
      color: ${(props) => props.theme.whiteColor};
      button{
        background: ${(props) => props.theme.whiteColor};
        color: ${(props) => props.theme.secondaryColor};
      }
    }
    img{
      width:100%;
    }
  }
  .card-flip .back {
    background: #eaeaed;
    color: #0087cc;
    line-height: 150px;
    text-align: center;
    transform: rotateY(180deg);
    background :url(${endPoints.ZAGGLE_CARD_BACK_NSDL.URL}) no-repeat;
    background-size:cover;
    padding-top: 35px;
    h3{
      color: ${(props) => props.theme.blackColor};
      font-weight: 900;
      text-align: center;
      padding-left: 70%;
      padding-top: 1px;
    }
    .footer{
      display:none;
    }
  }
`;

const StyledAntTable = styled.div`
.pro-ant-table{
  .ant-spin-container{
    .ant-table-content{
      .ant-table-body{
        margin:0px;
      }
      font-size:14px;
      border-radius:9px;
      .ant-table-thead{
      tr{
        th{
          background-color: ${(props) => props.theme.webGray};
          padding: 12px 10px;
          font-weight: 600;
          .ant-table-column-sorter{
            top: 7px;
            position: absolute;
          }
          .ant-table-column-sorter-up{
            font-size: 16px;
            &.on{
              color: ${(props) => props.theme.secondaryColor};
            }
          }
          .ant-table-column-sorter-down{
            font-size: 16px;
            &.on{
              color: ${(props) => props.theme.secondaryColor};
            }
          }
        }
      }
    }
    .ant-table-tbody{
      tr:hover:not(.ant-table-expanded-row) > td{
          background: ${(props) => props.theme.whiteColor};
        }
      tr{
        &.ant-table-row{
          &.redColor{
            td{
              color: ${(props) => props.theme.primaryColor};
              background: ${(props) => props.theme.lightRed};
              &:hover {
              color: ${(props) => props.theme.primaryColor};
              background: ${(props) => props.theme.lightRed};
              }
            }
          } 
        }
        &:nth-child(even){
          td {
            background: ${(props) => props.theme.whiteColor};
          }
        }
          td{
            padding: 16px 12px;  
          }
        }
      }
    }
    ul{
      li{
        border: none;
        a{
          font-weight: 600;
          border: none;
          color: ${(props) => props.theme.LandingBlack};
        }
      }
      .ant-pagination-item-active {
          background-color: ${(props) => props.theme.tintGray} !important;
        a{
          color: ${(props) => props.theme.primaryColor} !important;
        }
      }
    }
  } 
}
`;

const StyledDriverSalary = styled.div`
  .driver-salary-card{
    background: ${theme.CardGray};
  }
  .driver-salary-heading{
    font-weight: 500;
  }
  .driver-salary-headers{
    font-size: 12px;
    color: ${theme.CardLightGray};
  }
  .btns{
    height: auto;
    border-radius: 10px;
    padding: 10px 14px;
    line-height: normal;
    display: inline-block;
    &.selected-button{
      background: ${theme.primaryColor};
      border: 1px solid ${theme.primaryColor};
      color: ${theme.whiteColor};
      font-weight: 600;
    }
    &.unselected-button{
      background: ${theme.whiteColor};
      border: 1px solid ${theme.gray89};
      color: ${theme.LandingBlack};
      font-weight: 500;
    }
  }
  .noborder{
    border: none;
  }
`;

const StyledYesBankFullKyc = styled.div`
.kyc-input{
  &.ant-input{
    padding: 5px 12px;
    font-size: 15px;
    height: 42px;
    border-radius: 10px;
  }
}
`;

export {
  NsdlFlipCards,
  ZaggleCard,
  FlipCards,
  StyledAntTable,
  StyledDriverSalary,
  StyledYesBankFullKyc,
};



// WEBPACK FOOTER //
// client/containers/NetworkCards/StyledNetworkCard.js